import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsfEnum } from "@/utils/indicatorsEsf";
import { ResumeIndicatorC6Data } from "@/services/esus/indicator/esf/c6/getResumeIndicatorC6";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsfC6ResumeProps = {
	resume: ResumeIndicatorC6Data;
};

export function IndicatorEsfC6Resume({ resume }: Readonly<IndicatorEsfC6ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalElderlyCitizensInPeriodScore,
		resume.maxElderlyCitizensInPeriodScore
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos identificados"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalElderlyCitizens.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Cidadãos identificados"
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de idosos identificados que estão sendo monitorados no
								período informado
								<br />
								Idade igual ou superior a 60 anos em relação a data de início do
								período ou que <br />
								completarão 60 anos nos próximos 12 meses (para que seja iniciado o
								acompanhamento pelos
								<br />
								próximos 12 meses até a avaliação).
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos avaliados"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalElderlyCitizensInPeriod.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Cidadãos avaliados"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div>
								Quantidade de idosos identificados que estão sendo avaliados no
								período informado. <br />
								Idade igual ou superior a 60 anos em relação a data de início do
								período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Pontuação"
					value={resume.totalElderlyCitizensInPeriodScore.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Pontuação"
							message="Quantidade de pontos alcançados nas práticas realizadas no indicador(somatório de pontos de todos os cidadãos)"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="% Pontos alcançados"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsfEnum.C6,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="% Pontos alcançados"
							message="Percentual de pontos alcançados em relação a pontuação máxima do indicador"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
